import React from 'react'
import { Switch, Route } from 'react-router-dom'
// import AppRoute from '../AppRoute'
// import SettingsRoute from './Settings'
// import CategoriesRoute from './Categories'
// import ProductsRoute from './Products'
// import TablesRoute from './Tables'
// import PricingsRoute from './Pricings'
// import PlayersRoute from './Players'
// import UsersRoute from './Users'
// import CustomersRoute from './Customers'
// import LockersRoute from './Lockers'
import AdminTablesContainer from './Tables/containers/AdminTablesContainer'
import AdminPricingsContainer from './Pricings/containers/AdminPricingsContainer'
import AdminPlayersContainer from './Players/containers/AdminPlayersContainer'
import AdminCategoriesContainer from './Categories/containers/AdminCategoriesContainer'
import AdminProductsContainer from './Products/containers/AdminProductsContainer'
import AdminCustomersContainer from './Customers/containers/AdminCustomersContainer'
import AdminLockersContainer from './Lockers/containers/AdminLockersContainer'
import AdminUsersContainer from './Users/containers/AdminUsersContainer'
import AdminSettingsContainer from './Settings/containers/AdminSettingsContainer'
export default ({ match }) => (
  <Switch>
    <Route
      exact
      path={`${match.path}/tables`}
      component={AdminTablesContainer}
    />
    <Route
      exact
      path={`${match.path}/pricings`}
      component={AdminPricingsContainer}
    />
    <Route
      exact
      path={`${match.path}/players`}
      component={AdminPlayersContainer}
    />
    <Route
      exact
      path={`${match.path}/categories`}
      component={AdminCategoriesContainer}
    />
    <Route
      exact
      path={`${match.path}/products`}
      component={AdminProductsContainer}
    />
    <Route
      exact
      path={`${match.path}/customers`}
      component={AdminCustomersContainer}
    />
    <Route
      exact
      path={`${match.path}/lockers`}
      component={AdminLockersContainer}
    />
    <Route exact path={`${match.path}/users`} component={AdminUsersContainer} />
    <Route
      exact
      path={`${match.path}/settings`}
      component={AdminSettingsContainer}
    />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/routes/Admin/index.js